import React, { useEffect, useState } from 'react';
import './Qsite.css';
import axios from 'axios';

export default function Profile({ prmSpns, allSpns, btns, prfId }) {
	const [profile, setProfile] = useState({});

	useEffect(() => {
		if (Object.keys(profile).length === 0 && prfId !== '') {
			const initProfile = async () => {
				const { data } = await axios.get(`/getProfile4Qsite/${prfId}`);
				setProfile(data);
			};
			initProfile();
		}
	}, [profile, prfId]);

	return (
		<div className='row mb-2'>
			<div className='col-6 h-100 d-flex flex-column justify-content-end'>
				{prmSpns.map((prmSpn) => (
					<div className='spnDiv shadow' key={prmSpn._id}>
						<a href={prmSpn.url} target='_blank' rel='noreferrer'>
							{allSpns.map((spn) => (
								<div key={spn._id}>{spn._id === prmSpn.sponsorId && <img className='spnImg' src={spn.logo} alt={spn.name} />}</div>
							))}
						</a>
					</div>
				))}
			</div>
			<div className='col-6 h-100'>
				<img className='prfImg mb-4' src={profile.photo} alt={`${profile.fname} ${profile.lname}`} />
				{btns.map((btn) => (
					<a className='fw-bold fs-5 text-decoration-none' key={btn._id} href={btn.url} target='_blank' rel='noreferrer'>
						<div className='btnDiv shadow'>{btn.text}</div>
					</a>
				))}
			</div>
		</div>
	);
}
